import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,      // 5 min — data is fresh for 5 minutes
      gcTime: 30 * 60 * 1000,        // 30 min — keep cache for back-navigation
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,       // refetch when network reconnects
      retry: 1,                       // 1 retry on failure
    },
  },
});
